import React from "react";
import {Paper} from "@mui/material";
import Modal from "@mui/material/Modal";
import ProfileTextfield from "./ProfileTextfield";
import Loading from "../../../components/loader/Loading";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
};

const ProfileConfirmEmailCodeModal = ({
                                          open,
                                          handleClose,
                                          personalInfoFormValues,
                                          handleChange,
                                          handleSubmitEmailCode,
                                          loading,
                                      }) => {

    return (
        <>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Paper sx={style}>
                    <ProfileTextfield
                        sx={{marginBottom: "20px"}}
                        label="کد ارسال شده"
                        type="number"
                        placeholder="کد ارسال شده به ایمیل شما..."
                        value={personalInfoFormValues.email_code}
                        onChange={handleChange("email_code")}
                    />
                    <button className="btn btn-blue" onClick={handleSubmitEmailCode}>
                        {
                            loading.email_code ? (
                                <Loading color="#fff"/>
                            ) : "ثبت"
                        }
                    </button>
                </Paper>
            </Modal>
        </>
    );
};

export default ProfileConfirmEmailCodeModal;